import { render, staticRenderFns } from "./RapportScreen.vue?vue&type=template&id=51a8d430&"
import script from "./RapportScreen.vue?vue&type=script&lang=js&"
export * from "./RapportScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports